
import Modal from 'react-bootstrap/Modal';
import { useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";

import hands_img from '../../../assets/images/high-five-hand.svg';
import unlocked_img from '../../../assets/images/locker.svg';
import { Link } from "react-router-dom";
import { TitleH2 } from '../../../components/TitleH2';
import { Text } from '../../../components/Text';
import { Button } from '../../../components/Button';

export default function FolderCompletedModal (props) {

    const {show, onClose, nextFolderId, folderData, unlockedExam} = props
    const t = useSelector(selectTranslations)

    return (
        <Modal
            show={show}
            onHide={onClose}
            keyboard={false}
            centered
        >
            {unlockedExam ?
            <Modal.Body className="text-center">
                <img src={unlocked_img} alt="" className="mb-2 mx-auto" style={{width: '56px'}} />
                <TitleH2 className="text-center">{t.ofa.unlocked.title}</TitleH2>
                <Text className="text-center mb-4">{t.ofa.unlocked.text} <strong>{unlockedExam.title}</strong>.</Text>
                <Link to={`/exams/preview/${unlockedExam.exam_id}`} state={{exam: unlockedExam}}>
                    <Button className="mt-2 w-100 mx-auto" color="primary" onClick={onClose}>{t.ofa.unlocked.button}</Button>
                </Link>
                <Button className="mt-2 w-100 mx-auto" onClick={onClose} color="secondary">{t.ofa.unlocked.later}</Button>
            </Modal.Body>
            :
            <Modal.Body className="text-center">
                <img src={hands_img} alt="" className="mb-2 mx-auto" />
                <TitleH2 className="text-center">{t.folder.module_completed}</TitleH2>
                <Text className="text-center mb-4">{t.folder.module_completed_text}</Text>
                <Link to={nextFolderId ? `/folder/${nextFolderId}` : `/folder/${folderData?.parent_folder_id}`}>
                    <Button className="mt-2 w-100 mx-auto" color="primary" onClick={onClose}>
                        {nextFolderId ? t.folder.go_to_next_step : t.folder.back_to_folder}
                    </Button>
                </Link>
                <Button className="mt-2 w-100 mx-auto" onClick={onClose} color="secondary">{t.modals.close}</Button>
            </Modal.Body>
            }
        </Modal>
    )
}